import React, { useContext, useState } from 'react';
import dynamic from 'next/dynamic';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import AssessmentQuestion from '@/components/pages/assessments/AssessmentQuestion';
import AssessmentActions from '@/components/pages/assessments/AssessmentActions';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const DetailedTagList = dynamic(() => import('@/components/pages/assessments/screens/DetailedTagList'));
const LocationSelector = dynamic(() => import('@/components/pages/assessments/location/LocationSelector'));

function AssessmentScreen({ answer, handleNext, page }) {
  const { holdStep } = useContext(stepContext);
  const { css, cols } = useContext(displayContext);
  const [stepCanProceed, setStepCanProceed] = useState(false);
  const [selection, setSelection] = useState(answer);

  return (
    <Row className={css('assessment-step')} key={page.id}>
      <Col className={css(`assessment-step-question mobile-full-width-column ${cols.screen.leftClass}`)} {...cols.screen.left}>
        <Container fluid className={`${css('assessment-column-container')}`}>
          <AssessmentQuestion page={page} />
        </Container>
      </Col>
      <Col className={css(`assessment-screen-body mobile-full-width-column ${cols.screen.rightClass}`)} {...cols.screen.right}>
        <Container fluid className={css('assessment-column-container')}>
          {
            {
              detailed_tag_list_multiple: (
                <DetailedTagList data={page} setPageComplete={setStepCanProceed} handleAnswer={setSelection} answer={selection} multi={true} />
              ),
              detailed_tag_list_single: (
                <DetailedTagList data={page} setPageComplete={setStepCanProceed} handleAnswer={setSelection} answer={selection} multi={false} />
              ),
              location_map_selector: (
                <LocationSelector data={page} setPageComplete={setStepCanProceed} handleAnswer={setSelection} answer={selection} />
              )
            }[page.component.type]
          }
        </Container>
      </Col>
      <Col className={css(`${cols.screen.buttonClass}`)} {...cols.screen.buttons}>
        <AssessmentActions enableNext={stepCanProceed && !holdStep} showNext={true} handleNext={handleNext} selection={selection} />
      </Col>
    </Row>
  );
}

export default AssessmentScreen;
